//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
let d=[[[0,"ActiveSketchViewColor",1,0],[0,"AssociativeAlignment",1,0],[0,"BorderColor",1,0],[0,"CursorTracking",1,0],[0,"DisplayBorders",1,0],[0,"EnableSmoothEdgesForLWView",1,1],[0,"FaceDisplay",1,0],[0,"HandlingBodies",1,1],[0,"HandlingBodiesTypes",1,0],[0,"LargeAssemblyStepThreshold",1,0],[0,"LoadComponentsOnDemand",1,0],[0,"OnLegacyViewUpdate",1,0],[0,"OnViewSelection",1,0],[0,"PreviewStyle",1,0],[0,"SelectGeometryProjectedAsArcs",1,0],[0,"ShowFacetEdges",1,0],[0,"UseLineAntialiasing",1,0],[0,"UseTranslucency",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.ViewWorkflowBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.ViewWorkflowBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ViewWorkflowBuilder.Style = Object.freeze({
    "Border" : "Border", "Wireframe" : "Wireframe", "HiddenWireframe" : "HiddenWireframe", "Shaded" : "Shaded"});

SPLM.Drawings.ViewWorkflowBuilder.Display = Object.freeze({
    "DisplayandEmphasize" : "DisplayandEmphasize", "CurvesOnly" : "CurvesOnly"});

SPLM.Drawings.ViewWorkflowBuilder.Splarcs = Object.freeze({
    "Always" : "Always", "NeverForAutomatic" : "NeverForAutomatic", "Never" : "Never"});

SPLM.Drawings.ViewWorkflowBuilder.Handlingbodies = Object.freeze({
    "OmitBodiesfromView" : "OmitBodiesfromView", "StopUpdateandNotifyUser" : "StopUpdateandNotifyUser", "StopUpdate" : "StopUpdate", "Generate" : "Generate"});

SPLM.Drawings.ViewWorkflowBuilder.HandlingBodiesType = Object.freeze({
    "OmitBodiesfromView" : "OmitBodiesfromView", "StopUpdateandNotifyUser" : "StopUpdateandNotifyUser", "StopUpdate" : "StopUpdate", "Generate" : "Generate"});

export default SPLM;